import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { AddressType, clientSearchResponseAddressStore } from '../models/address.model'
import { setAddressAction, resetAddressAction } from '../store/address.reducer'
import { selectAddressByType, selectAddressFromClientSearch } from '../store/address.selectors'

import { RootState } from '~/core/store/root.reducer'
import { selectIsCartera } from '~/sale/store/sale.selectors'
import { LineTypes } from '~/tariff/model/tariff.model'

export default function useClientAddress() {
  const dispatch = useDispatch()
  const mainLineSIMAddress = useSelector((state: RootState) =>
    selectAddressByType(state, LineTypes.MAIN, AddressType.SIM),
  )
  const isCartera = useSelector(selectIsCartera)
  const addressFromClientSearch: clientSearchResponseAddressStore = useSelector(
    selectAddressFromClientSearch,
  )

  useEffect(() => {
    if (
      isCartera &&
      addressFromClientSearch?.streetName !== '' &&
      mainLineSIMAddress.data.streetName === ''
    ) {
      dispatch(
        setAddressAction({
          id: LineTypes.MAIN,
          addressType: AddressType.SIM,
          address: addressFromClientSearch,
        }),
      )
    }
  }, [])

  function deleteClientSearchAddress(id: string, addressType: string) {
    dispatch(resetAddressAction({ id, addressType }))
  }

  return deleteClientSearchAddress
}
